
import Filter1 from "./../assets/img/template/filter1.png";

import Station1 from "./../assets/img/giftshop/landing/1.png";
import Station2 from "./../assets/img/giftshop/landing/2.png";
import Station3 from "./../assets/img/giftshop/landing/3.png";
import Station4 from "./../assets/img/giftshop/landing/4.png";
import Station11 from "./../assets/img/giftshop/landing/101.png";
import Station12 from "./../assets/img/giftshop/landing/102.png";
import Station13 from "./../assets/img/giftshop/landing/103.png";

import Station21 from "./../assets/img/giftshop/landing/201.png";
import Station22 from "./../assets/img/giftshop/landing/202.png";

import Station31 from "./../assets/img/giftshop/landing/301.png";
import Station32 from "./../assets/img/giftshop/landing/302.png";
import Station33 from "./../assets/img/giftshop/landing/303.png";

import Station41 from "./../assets/img/giftshop/landing/401.png";
import Station42 from "./../assets/img/giftshop/landing/402.png";
import Station43 from "./../assets/img/giftshop/landing/403.png";


import PencilTxt from "./../assets/img/giftshop/landing/typo/101.png";
import KlimtTxt from "./../assets/img/giftshop/landing/typo/102.png";
import BotanicalTxt from "./../assets/img/giftshop/landing/typo/103.png";

import WynwoodCaricatureTxt from "./../assets/img/giftshop/landing/typo/301.png";
import HobbyCaricatureTxt from "./../assets/img/giftshop/landing/typo/302.png";
import Cartoon90Txt from "./../assets/img/giftshop/landing/typo/303.png";

import GraffitiMonochromeTxt from "./../assets/img/giftshop/landing/typo/401.png";
import PopGraffitTxt from "./../assets/img/giftshop/landing/typo/402.png";
import SurrealGraffitiTxt from "./../assets/img/giftshop/landing/typo/403.png";

import MonroeStyleTxt from "./../assets/img/giftshop/landing/typo/201.png";
import LichtensteinTxt from "./../assets/img/giftshop/landing/typo/202.png";

import StationIdleBG1 from "./../assets/img/giftshop/landing/station-1-bg.png";
import StationIdleBG2 from "./../assets/img/giftshop/landing/station-2-bg.png";
import StationIdleBG3 from "./../assets/img/giftshop/landing/station-3-bg.png";
import StationIdleBG31 from "./../assets/img/giftshop/landing/station-3-bg-hobby.png";
import StationIdleBG4 from "./../assets/img/giftshop/landing/station-4-bg.png";
import CaricatureTxt from "./../assets/img/caricature/Caricature.png";


import WynwoodTxt from "./../assets/img/wynwood-walls/Wynwood Art.png";
import Wynwood1 from "./../assets/img/wynwood-walls/wynwood5.png";

import Frame1 from "./../assets/img/e-commerce/frame.png";
import Frame2 from "./../assets/img/e-commerce/frame.png";
import Frame3 from "./../assets/img/e-commerce/frame.png";
import Frame4 from "./../assets/img/e-commerce/frame.png";

import Canvas from "./../assets/img/e-commerce/canvas-1.png";
import TShirt from "./../assets/img/e-commerce/t-shirt-1.png";
import Cap from "./../assets/img/e-commerce/cap-1.png";
import Bag from "./../assets/img/e-commerce/bag-1.png";
import Mug from "./../assets/img/e-commerce/mug-1.png";
import Megnet from "./../assets/img/e-commerce/custom-design-1.png";
import Apron from "./../assets/img/e-commerce/apron-1.png";
import MousePad from "./../assets/img/e-commerce/mouse-pad-1.png";



export const merchandiseData = [
  {
    id: 1, name: 'Canvas', imgURL: Canvas,
    product_sizes: [
      { id: 1, size: 'Small 6x6 inches', price: 10 },
      { id: 2, size: 'Medium 12x6 inches', price: 20 },
      { id: 3, size: 'Large 24x36 inches', price: 30 },
      { id: 4, size: 'Super Large 40x60 inches', price: 40 }
    ],
    color: [],
    brand_name: '',
    basePrice: 10
  },
  {
    id: 2, name: 'T-Shirt', imgURL: TShirt,
    product_sizes: [
      { id: 1, size: 'Small ', price: 10 },
      { id: 2, size: 'Medium ', price: 20 },
      { id: 3, size: 'Large', price: 30 },
      { id: 4, size: 'XL', price: 40 },
      { id: 5, size: 'XXL', price: 60 }
    ],
    color: ['Black', 'White', "Green", "Navy Blue", 'Red'],
    brand_name: '',
    basePrice: 10
  },
  {
    id: 3, name: 'Cap', imgURL: Cap, product_sizes: [
      { id: 1, size: 'Small ', price: 10 },
      { id: 2, size: 'Medium ', price: 20 },
      { id: 3, size: 'Large', price: 30 },
      { id: 4, size: 'XL', price: 40 },
      { id: 4, size: 'XXL', price: 60 }
    ],
    color: ['Black', 'White', "Green", "Navy Blue", 'Red'], brand_name: '', basePrice: 10
  },
  {
    id: 4, name: 'Bag', imgURL: Bag, product_sizes: [], color: ['Black', 'White', "Green", "Navy Blue", 'Red'], brand_name: '', basePrice: 10
  },
  { id: 5, name: 'Mug', imgURL: Mug, product_sizes: [], color: ['Black', 'White', "Green", "Navy Blue", 'Red'], brand_name: '', basePrice: 10 },
  // { id: 6, name: 'Phone case', imgURL: PhoneCase, product_sizes: [], color: ['Black', 'White', "Green", "Navy Blue", 'Red'], brand_name: 'Apple', basePrice: 10 },
  {
    id: 6, name: 'Refrigerator Magnet', imgURL: Megnet, product_sizes: [{ id: 1, size: '2x2 inches ', price: 10 },
    { id: 2, size: '2x3 inches ', price: 20 },
    { id: 3, size: '3x3 inches', price: 30 },
    { id: 4, size: '3x4 inches', price: 40 },
    { id: 4, size: '4x6 inches', price: 60 }], color: [], brand_name: '', basePrice: 10
  },
  {
    id: 7, name: 'Apron', imgURL: Apron, product_sizes: [{ id: 1, size: 'Small ', price: 10 },
    { id: 2, size: 'Medium ', price: 20 },
    { id: 3, size: 'Large', price: 30 },
    { id: 4, size: 'XL', price: 40 },
    { id: 4, size: 'XXL', price: 60 }],
    color: ['Black', 'White', "Green", "Navy Blue", 'Red'], brand_name: '', basePrice: 10
  },
  // {
  //   id: 9, name: 'Key Chain', imgURL: KeyChain, product_sizes: [{ id: 1, size: '2x2 inches ', price: 10 },
  //   { id: 2, size: '2x3 inches ', price: 20 },
  //   { id: 3, size: '3x3 inches', price: 30 },
  //   { id: 4, size: '3x4 inches', price: 40 },
  //   { id: 4, size: '4x6 inches', price: 60 }], color: [], brand_name: '', basePrice: 10
  // },
  {
    id: 8, name: 'Mousepad', imgURL: MousePad, product_sizes: [{ id: 1, size: '9x7.5 inches ', price: 10 },
    { id: 2, size: '10x8 inches ', price: 20 },
    { id: 3, size: '11x9 inches', price: 30 },
    { id: 4, size: '8x8 inches', price: 40 },
    { id: 5, size: '12x10 inches', price: 70 },
    { id: 6, size: 'Extended 31.5x11.8 inches', price: 100 },

    ], color: [], brand_name: '', basePrice: 10
  },
]

export const frameData = [
  {
    id: 1,
    name: 'Mini Moment',
    imgURL: Frame1,
    price: '4',
    description: 'Sweet, personal, shareable'
  },
  {
    id: 2,
    name: 'Everyday Frame',
    imgURL: Frame2,
    price: '8',
    description: 'Classic photo frame size'
  },
  {
    id: 3,
    name: 'Gallery Pick',
    imgURL: Frame3,
    price: '35',
    description: 'Elegant, ready for gallery walls'
  },
  {
    id: 4,
    name: 'Statement Wall',
    imgURL: Frame4,
    price: '79',
    description: 'Bold, centerpiece-worthy'
  },
]


export const photoFilters = [
  { id: "original", label: "Original", imgURL: Filter1 },
  { id: "bw", label: "Black and White", imgURL: Filter1 },
  { id: "vintage", label: "Vintage", imgURL: Filter1 },
  { id: "bright", label: "Bright", imgURL: Filter1 },
  { id: "cool", label: "Cool", imgURL: Filter1 },
  { id: "soft", label: "Soft", imgURL: Filter1 },
];

export const stationDataNew = [
  {
    id: 1,
    name: "Classic Art",
    tittle: 'Classic Art Selfie Station',
    href: "/all",
    imgURL: Station1,
    bg: [StationIdleBG1],
    nextURL: '/pencil-sketch/upload-image-qr-code',
    type: 'classic-art',
    children: [
      {
        id: 101,
        name: "Pencil Sketch",
        href: "/idle",
        imgURL: Station11,
        bg: [StationIdleBG1],
        txtImg: PencilTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'pencil-sketch',
      },
      {
        id: 102,
        name: "Klimt Style",
        href: "/idle",
        imgURL: Station12,
        bg: [StationIdleBG1],
        txtImg: KlimtTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'klimt-style',
      },
      {
        id: 103,
        name: "Botanical Surreal",
        href: "/idle",
        imgURL: Station13,
        bg: [StationIdleBG1],
        txtImg: BotanicalTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'botanical-surreal',
      },

    ]
  },
  {
    id: 2,
    name: "Pop Art",
    tittle: 'Pop Art Selfie Station',
    href: "/all",
    imgURL: Station2,
    bg: [StationIdleBG2],
    txtImg: CaricatureTxt,
    nextURL: '/caricature/upload-image-qr-code',
    type: 'pop-art',
    children: [
      {
        id: 201,
        name: "Andy Warhol’s Marilyn Monroe Style",
        href: "/idle",
        imgURL: Station21,
        bg: [StationIdleBG2],
        txtImg: MonroeStyleTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'andy-warhol-marilyn-monroe-style',
      },
      {
        id: 202,
        name: "Lichtenstein",
        href: "/idle",
        imgURL: Station22,
        bg: [StationIdleBG2],
        txtImg: LichtensteinTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'lichtenstein',
      },
    ]
  },
  {
    id: 3,
    name: "Caricature/Cartoon",
    tittle: 'Caricature/Cartoon Selfie Station',
    href: "/all",
    imgURL: Station3,
    bg: [StationIdleBG3],
    txtImg: WynwoodTxt,
    nextURL: '/wynwood/upload-image-qr-code',
    type: 'caricature-cartoon',
    children: [
      {
        id: 301,
        name: "Wynwood Caricature",
        href: "/idle",
        imgURL: Station31,
        bg: [StationIdleBG3],
        txtImg: WynwoodCaricatureTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'wynwood-caricature',
      },
      {
        id: 302,
        name: "Hobby Caricature",
        href: "/idle",
        imgURL: Station32,
        bg: [StationIdleBG31],
        txtImg: HobbyCaricatureTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'hobby-caricature',
      },
      {
        id: 303,
        name: "90’s cartoon",
        href: "/idle",
        imgURL: Station33,
        bg: [StationIdleBG3],
        txtImg: Cartoon90Txt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: '90-cartoon',
      },
    ]
  },
  {
    id: 4,
    name: "Graffiti Art",
    tittle: 'Graffiti Art Selfie Station',
    href: "/all",
    imgURL: Station4,
    bg: [StationIdleBG4],
    txtImg: Wynwood1,
    nextURL: '/cartoon/upload-image-qr-code',
    type: 'graffiti-art',
    children: [
      {
        id: 401,
        name: "Graffiti Monochrome",
        href: "/idle",
        imgURL: Station41,
        bg: [StationIdleBG4],
        txtImg: GraffitiMonochromeTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'graffiti-monochrome',
      },
      {
        id: 402,
        name: "Pop Graffiti",
        href: "/idle",
        imgURL: Station42,
        bg: [StationIdleBG4],
        txtImg: PopGraffitTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'pop-graffiti',
      },
      {
        id: 403,
        name: "Neon Surreal Graffiti",
        href: "/idle",
        imgURL: Station43,
        bg: [StationIdleBG4],
        txtImg: SurrealGraffitiTxt,
        nextURL: '/pencil-sketch/upload-image-qr-code',
        type: 'neon-surreal-graffiti',
      },
    ]
  },
];


// utils/formatPrice.ts
export const formatPrice = (price: number | string | undefined | null): string => {
  if (price === undefined || price === null) {
    return "$0.00";
  }
  const value = typeof price === "string" ? parseFloat(price) || 0 : price || 0;
  return `$${value.toFixed(2)}`;
};

export const bgImages = {
  "caricature": "https://d2s4ngnid78ki4.cloudfront.net/winwood_background.jpg",
  "cartoon": "https://d2s4ngnid78ki4.cloudfront.net/AIStations/ai_station_cartoon_bg.png",
};

